/**
 * Reads a boolean port value. Checkbox controls are serialized as either a real
 * boolean or its string form, depending on when the graph was saved.
 */
export function parseBoolean(value: unknown, fallback?: boolean) {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return fallback;
}
